export const environment = {
  production: false,
  appSwitcherEnvironmentName: 'qa',
  version: 'v1',
  clientId: '6194d462-eed7-47f7-afd1-3a4834c9fddf',
  API_CONFIGURATION_BASE: 'https://uat-configuration.wolop.app/api/v1',
  API_AUTH_DOMAIN: 'https://uat-auth.wolop.app',
  WEB_AUTH_DOMAIN: 'https://uat-auth.wolop.app',
};
